import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { PageImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/pageImpression.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (): void => {
    const event: AnalyticsEvent<PageImpressionTrackingInfo> = {
        event: EventType.PageImpression,
        payload: {
            eventData: {}
        }
    };

    TrackingService.track(event);
};
